import { render, staticRenderFns } from "./add-exam-questions.vue?vue&type=template&id=66fa59c6"
import script from "./add-exam-questions.vue?vue&type=script&lang=js"
export * from "./add-exam-questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports